import axios from 'axios'
import config from '../../../config'

let WeightApi = {
  deleteWeightReading: function (progressId, trackingId) {
    return axios.delete(config.apiUrl + 'tracking/weight/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    })
  },
  updateWeightTracking: function (model) {
    return axios.put(config.apiUrl + 'tracking/weight/', model);
  },
  getWeightTrackingCard: function () {
    let self = this;
    return axios.get(config.apiUrl + 'tracking/weight/card/?requestFrom=web')
  },
  postWeightTracking: function (model) {
    return axios.post(config.apiUrl + 'tracking/weight/', model)
  },
  getWeightTrackingDetail: function (page, page_size) {
    return axios.get(config.apiUrl + 'tracking/weight/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  },
  getWaistHipTrackingDetail: function(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/waist-hip/', {
      params: {
        page: page,
        page_size: page_size
      }
    });
  },
  deleteWaistHipReading: function (trackingId) {
    return axios.delete(config.apiUrl + 'tracking/waist-hip/' + trackingId)
  },
  updateWaistHipTracking: function (model) {
    return axios.put(config.apiUrl + 'tracking/waist-hip/' + model.tracking_id, model)
  },
};

export default WeightApi



// WEBPACK FOOTER //
// ./src/api/Tracking/Weight/index.js